import { client } from '~shared/api';

import { KeycloakConfig } from '../config/keycloak';
import { AuthDto, AuthDtoScheme, AuthReqKeycloakDto } from '../model/dto';

/**
 * Авторизоваться на сервере
 * @param access_token
 */
export async function fetchAuth(access_token: string): Promise<AuthDto> {
	const data = await client.post('/auth', { access_token } as AuthReqKeycloakDto);
	return AuthDtoScheme.parse(data);
}

/**
 * Получить токен от Keycloak
 * @param withInit
 */
export async function fetchKeycloakToken(withInit = false): Promise<string | null> {
	const status = withInit
		? await KeycloakConfig.init({
				onLoad: 'login-required',
				checkLoginIframe: false,
				pkceMethod: 'S256',
			})
		: true;

	return status && KeycloakConfig.token ? KeycloakConfig.token : null;
}

/**
 * Разлогиниться в Keycloak
 */
export async function keycloakLogout() {
	await KeycloakConfig.logout({ logoutMethod: 'POST' });
}
